(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const groupSelectors = [
    '.mosaic-grid',
    '.howitworks__grid',
    '.stats-cards__grid',
    '.rs22__container',
    '.fdm-materials-grid',
    '.industry-grid',
    '.faq-accordion',
    '.mos__grid'
  ];
  const itemSelector = [
    '.mosaic-card',
    '.howitworks__card',
    '.stats-card',
    '.rs22-card',
    '.fdm-material-card',
    '.industry-item',
    '.faq-item',
    '.mos__cell'
  ].join(',');

  let observer;

  function prepare(root = document) {
    const groups = root.querySelectorAll(groupSelectors.join(','));

    groups.forEach((group) => {
      const items = Array.from(group.children).filter((item) => item.matches(itemSelector));

      items.forEach((item, index) => {
        if (item.dataset.pjEffectsReady === 'true') return;

        item.dataset.pjEffectsReady = 'true';
        item.classList.add('pj-reveal');
        item.style.setProperty('--pj-reveal-delay', `${Math.min(index, 5) * 90}ms`);

        if (items.length > 1) {
          if (index % 3 === 0) item.classList.add('pj-reveal--left');
          if (index % 3 === 2) item.classList.add('pj-reveal--right');
        }

        if (item.matches('.fdm-material-card, .faq-item')) {
          const line = document.createElement('span');
          line.className = 'pj-line-draw';
          line.setAttribute('aria-hidden', 'true');
          item.appendChild(line);
        }

        if (reduceMotion.matches || !observer) {
          item.classList.add('is-visible');
        } else {
          observer.observe(item);
        }
      });
    });
  }

  function init() {
    document.documentElement.classList.add('pj-effects-ready');

    if (!reduceMotion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    }

    prepare();
    document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
